<div class="prompt-hints-dropdown" [class.visible]="isVisible">
  <div class="prompt-hints-content">
    <div class="prompt-hints-list">
      @for (hint of promptHints; track $index; let i = $index) {
        <div
          class="prompt-hint-item"
          [class.selected]="i === selectedIndex"
          (click)="selectHint(hint)"
          (mouseenter)="onHintHover(i)"
          >
          <mat-icon class="hint-icon">search</mat-icon>
          <span class="hint-text">{{ hint }}</span>
          <mat-icon class="hint-arrow">north_east</mat-icon>
        </div>
      }
    </div>
  </div>
</div>
